<template lang="pug">
#modal-selecionar-territorios-py
    el-dialog.modal-selecionar-territorios-py-content(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='1200px'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.relatorioRastreabilidade.cadastro.selecioneTerritorioDesejaAdicionar') }}

        .el-collapse-item__container
            el-table(
                :key="listagemTableKey('territorios-modal-py', dadosPaginado, paginaAtual)",
                ref='tabelaModalSelecionarTerritoriosRef',
                :data='dadosPaginado',
                style='width: 100% !important'
            )
                el-table-column(width='50')
                    .template(slot-scope='scope')
                        el-checkbox(
                            :value='isTerritorioSelecionado(scope.row.id)',
                            :disabled='idsTerritoriosEmUso.includes(scope.row.id)',
                            @change='toggleTerritorio(scope.row)'
                        )

                el-table-column(
                    :label='$t("mensagens.relatorioRastreabilidade.cadastro.territorio")',
                    width='300'
                )
                    .template(slot-scope='scope')
                        span {{ scope.row.nome }}

                el-table-column(
                    :label='$t("mensagens.relatorioRastreabilidade.cadastro.codigoLyra")',
                    width='300'
                )
                    .template(slot-scope='scope')
                        span {{ scope.row.codigoLyra }}

                el-table-column(label='Finca', width='100')
                    .template(slot-scope='scope')
                        span(
                            v-if='scope.row.finca !== null && scope.row.finca !== "null"'
                        ) {{ scope.row.finca }}
                        span(v-else) -

                el-table-column(label='Padron', width='100')
                    .template(slot-scope='scope')
                        span(
                            v-if='scope.row.padron !== null && scope.row.padron !== "null"'
                        ) {{ scope.row.padron }}
                        span(v-else) -

                el-table-column(
                    :label='$t("mensagens.relatorioRastreabilidade.cadastro.distritoDepartamento")',
                    prop='distritoDepartamento',
                    width='250'
                )
                    template(slot-scope='scope')
                        span(
                            v-if='scope.row.distrito && scope.row.departamento'
                        ) {{ scope.row.distrito.nome }} / {{ scope.row.departamento.nome }}
                        span(v-else) -

                el-table-column(
                    :label='$t("mensagens.relatorioRastreabilidade.cadastro.saldo")',
                    min-width='280'
                )
                    template(slot-scope='scope')
                        .saldo-container(v-if='scope.row.saldoTerritorioPy')
                            .saldo-info
                                .saldo-labels
                                    span.saldo-label.disponivel
                                        i.el-icon-circle-check
                                        | {{ $t('mensagens.relatorioRastreabilidade.cadastro.saldoDisponivel') }}: {{ formatarSaldo(scope.row.saldoTerritorioPy[0].saldoCapacidadeProdutiva) }}
                                    span.saldo-label.comprometido
                                        i.el-icon-warning
                                        | {{ $t('mensagens.relatorioRastreabilidade.cadastro.saldoComprometido') }}: {{ formatarSaldo(scope.row.saldoTerritorioPy[0].saldoConsumidoCapacidadeProdutiva) }}
                            .saldo-progress
                                el-tooltip(
                                    :content='getTooltipContent(scope.row)',
                                    placement='top'
                                )
                                    .progress-bar
                                        .progress-fill.disponivel(:style='{ width: calcularPercentual(scope.row.saldoTerritorioPy[0].saldoCapacidadeProdutiva, scope.row) + "%" }')
                                        .progress-fill.comprometido(:style='{ width: calcularPercentual(scope.row.saldoTerritorioPy[0].saldoConsumidoCapacidadeProdutiva, scope.row) + "%" }')
                        span(v-else) -

        .c-pagination
            el-pagination(
                background,
                :page-size='pageCount',
                :pager-count='pageCount',
                :current-page.sync='paginaAtual',
                layout='prev, pager, next',
                :total='totalRegistros',
                @current-change='mudarPagina'
            )

        //- .informar-car-manualmente-car
        //-     el-radio(v-model='dadoSelecionado', label='Informar manualmente') {{ $t('mensagens.relatorioRastreabilidade.cadastro.informarManualmente') }}

        footer.my-3(slot='footer')
            el-button(@click='fecharModal')
                | {{ $t('mensagens.comuns.voltar') }}
            div(v-if='!territoriosSelecionados.length')
                el-tooltip(
                    effect='dark',
                    :content='$t("mensagens.relatorioRastreabilidade.cadastro.selecioneUmCarAntesDeConfirmar")',
                    placement='top'
                )
                    el-button(
                        type='primary',
                        @click='retornarDadosSelecionado'
                    )
                        | {{ $t('mensagens.comuns.confirmar') }}
            div(v-else)
                el-button(type='primary', @click='retornarDadosSelecionado')
                    | {{ $t('mensagens.comuns.confirmar') }} ({{ territoriosSelecionados.length }})
</template>

<script>
import TerritorioService from '@/services/TerritorioService';

export default {
    name: 'ModalSelecionarTerritoriosPY',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        dados: {
            type: Array,
            required: true
        },
        idsTerritoriosEmUso: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            territoriosSelecionados: [],
            paginaAtual: 1,
            pageCount: 5
        };
    },

    watch: {
        show: function () {
            if (!this.show) return;
            this.territoriosSelecionados = [];
        }
    },

    computed: {
        totalRegistros() {
            return this.dados?.length || 0;
        },

        dadosPaginado() {
            const inicio = (this.paginaAtual - 1) * this.pageCount;
            const fim = inicio + this.pageCount;

            return this.dados?.slice(inicio, fim);
        }
    },

    methods: {
        isTerritorioSelecionado(id) {
            return this.territoriosSelecionados.some((t) => t.id === id);
        },

        toggleTerritorio(territorio) {
            if (this.idsTerritoriosEmUso.includes(territorio.id)) {
                return;
            }

            const idx = this.territoriosSelecionados.findIndex(
                (t) => t.id === territorio.id
            );
            if (idx >= 0) {
                this.territoriosSelecionados.splice(idx, 1);
            } else {
                this.territoriosSelecionados.push(territorio);
            }
        },

        retornarDadosSelecionado() {
            if (!this.territoriosSelecionados.length) {
                return;
            }
            this.$emit(
                'retornarDadosSelecionados',
                [...this.territoriosSelecionados]
            );
        },

        mudarPagina(currentPage) {
            this.paginaAtual = currentPage;
        },

        fecharModal() {
            try {
                this.$messageBox
                    .confirm(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.alertaDadosNaoSeraoSalvos'
                        ),
                        this.$t('mensagens.comuns.aviso'),
                        {
                            confirmButtonText: this.$t('mensagens.comuns.sim'),
                            cancelButtonText: this.$t(
                                'mensagens.relatorioRastreabilidade.cadastro.permanecer'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.territoriosSelecionados = [];
                        this.$emit('voltar');
                    })
                    .catch(() => {});
            } catch (erro) {}
        },

        async realizarBuscaAPI() {
            try {
                const { data } =
                    await TerritorioService.buscarTerritoriosRevendaPY(
                        this.parametros,
                        this.paginacao.pagina
                    );

                this.territorios = data.content;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroRequisicao'
                    )
                });
            }
        },

        formatarSaldo(valor) {
            if (valor === null || valor === undefined) {
                return '0';
            }
            return new Intl.NumberFormat('pt-BR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            }).format(valor);
        },

        calcularPercentual(valor, row) {
            if (!row.saldoTerritorioPy || !row.saldoTerritorioPy.length) {
                return 0;
            }

            const saldo = row.saldoTerritorioPy[0];
            const total = saldo.capacidadeProdutiva || 0;

            if (total === 0) return 0;

            return ((valor / total) * 100).toFixed(2);
        },

        getTooltipContent(row) {
            if (!row.saldoTerritorioPy || !row.saldoTerritorioPy.length) {
                return '';
            }

            const saldo = row.saldoTerritorioPy[0];

            const total = this.formatarSaldo(saldo.capacidadeProdutiva || 0);
            const disponivel = this.formatarSaldo(saldo.saldoCapacidadeProdutiva || 0);
            const comprometido = this.formatarSaldo(saldo.saldoConsumidoCapacidadeProdutiva || 0);

            const percDisponivel = this.calcularPercentual(saldo.saldoCapacidadeProdutiva || 0, row);
            const percComprometido = this.calcularPercentual(saldo.saldoConsumidoCapacidadeProdutiva || 0, row);

            const labelTotal = this.$t('mensagens.relatorioRastreabilidade.cadastro.saldoTotal');
            const labelDisponivel = this.$t('mensagens.relatorioRastreabilidade.cadastro.saldoDisponivel');
            const labelComprometido = this.$t('mensagens.relatorioRastreabilidade.cadastro.saldoComprometido');

            return `${labelTotal}: ${total}  ${labelDisponivel}: ${disponivel} (${percDisponivel}%) ${labelComprometido}: ${comprometido} (${percComprometido}%)`;
        }

    }
};
</script>

<style lang="scss">
#modal-selecionar-territorios-py {
    footer {
        display: flex;
        justify-content: space-between;
    }

    .c-pagination {
        text-align: center;
        margin-top: 30px;
    }

    label {
        margin: 0 !important;
    }

    .informar-car-manualmente-car {
        display: flex;
        margin-top: 24px;
        gap: 5px;
        align-items: center;
        flex-wrap: wrap;
        background-color: #e7e7e7;
        border-radius: 5px;
        padding: 8px 8px;
        min-height: 6px;
    }

    .saldo-container {
        padding: 8px 0;
    }

    .saldo-info {
        margin-bottom: 8px;
    }

    .saldo-labels {
        display: flex;
        justify-content: space-between;
        gap: 12px;
        font-size: 11px;
        margin-bottom: 6px;
    }

    .saldo-label {
        display: flex;
        align-items: center;
        gap: 4px;
        font-weight: 500;

        i {
            font-size: 12px;
        }

        &.disponivel {
            color: var(--primary);

            i {
                color: var(--primary);
            }
        }

        &.comprometido {
            color: #e6a23c;

            i {
                color: #e6a23c;
            }
        }
    }

    .saldo-progress {
        width: 100%;
    }

    .progress-bar {
        display: flex;
        width: 100%;
        height: 20px;
        background-color: #f0f0f0;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
            transform: scale(1.02);
        }
    }

    .progress-fill {
        height: 100%;
        transition: width 0.4s ease;
        position: relative;

        &.disponivel {
            background: var(--primary);
        }

        &.comprometido {
            background: linear-gradient(90deg, #e6a23c 0%, #f5a742 100%);
        }

        &:first-child:not(:only-child) {
            border-right: 1px solid rgba(255, 255, 255, 0.3);
        }
    }
}

.modal-selecionar-territorios-py-content {
    .el-dialog__header {
        padding: 20px;
        padding-bottom: 10px;
        background: var(--primary) !important;
        color: var(--white);
        padding-bottom: 12px;
        padding-top: 12px;
    }

    .el-dialog__headerbtn {
        top: 10px;
    }

    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }

    .modal-analise-elegibilidade--header {
        display: flex;
        align-items: center;
    }
}
</style>
